import { Box, Flex, Image, Stack, Text } from "@chakra-ui/react";
import React from "react";
import { useParams } from "react-router-dom";
import { allProjects } from "./ProjectData";

function ProjectDetails() {
  const { projectName } = useParams(); 
  const projectData = allProjects[projectName];

  if (!projectData) {
    return (
      <Box textAlign="center" mt={10}>
        <Text fontSize="2xl" color="red.500">Project Not Found</Text>
      </Box>
    );
  }

  const {
    intro,
    year,
    month,
    points,
    images,
    keyFeaturesDescription,
    impact
  } = projectData;

  return (
    <Box bg="#FFFDF7" py={12} h="full">
      <Stack gap={2} maxW="80%" mx="auto">
        <Box>
          <Text fontSize="3xl" textAlign="center" color="#BFA585" className="fade-in-up">
            {intro.heading}
          </Text>
          <Text className="fade-in-up" textAlign="center">
            {intro.description}
          </Text>
        </Box>

        <Flex justify="space-between" py={10} flexWrap="wrap">
          <Box fontSize="3xl">
            <Text className="fade-in-up">{year}</Text>
            <Text fontWeight="bold" className="fade-in-up">
              {month}
            </Text>
          </Box>

          <Box fontSize="1.5xl" fontWeight="medium">
            <Text className="fade-in-up">
              What We Managed To Accomplish For Them
            </Text>
            {points.map((point, index) => (
              <Text key={index}>• {point}</Text>
            ))}
          </Box>
        </Flex>

        <Image src={images.logo} />
        <Image src={images.projectImg} top="-123px" position="relative" />

        <Box fontSize="1.5xl">
          <Text className="fade-in-up">Key Features</Text>
          {points.map((point, index) => (
            <Text key={index}>• {point}</Text>
          ))}
        </Box>

        <Text className="fade-in-up">{keyFeaturesDescription}</Text>

        <Text margin="auto" fontWeight="bold" fontSize="3xl" mb={4}>
          Impact & Results
        </Text>

        <Flex
          wrap="wrap"
          justify="center"
          align="center"
          gap={{ base: 4, md: 6 }}
          mt={6}
        >
          {impact.map((item, index) => (
            <Box
              key={index}
              position="relative"
              w={{ base: "190px", md: "180px" }}
              textAlign="center"
            >
              <Image src={item.img} alt="Card" w="100%" />
              <Box
                position="absolute"
                top="40%"
                left="50%"
                transform="translate(-50%, -50%)"
                color="white"
              >
                <Text fontSize={{ base: "lg", md: "2xl" }} fontWeight="bold">
                  {item.value}
                </Text>
                <Text fontSize="xs" dangerouslySetInnerHTML={{ __html: item.label }} />
              </Box>
            </Box>
          ))}
        </Flex>
      </Stack>
    </Box>
  );
}

export default ProjectDetails;
